// extracted by mini-css-extract-plugin
export default {"player":"player_player__EJX86","button":"player_button__9qoaL"};